/**
 * conversations
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from './configuration';
//@ts-ignore
import { BASE_PATH, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Meta data for ad
 * @export
 * @interface AdMetaData
 */
export interface AdMetaData {
    /**
     * Ad title
     * @type {string}
     * @memberof AdMetaData
     */
    title?: string;
    /**
     * Ad image URL
     * @type {string}
     * @memberof AdMetaData
     */
    imageUrl?: string;
}
/**
 *
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * A URI identifier that categorizes the error
     * @type {string}
     * @memberof ApiError
     */
    type?: string;
    /**
     * The HTTP response code
     * @type {number}
     * @memberof ApiError
     */
    status?: number;
    /**
     * A short, human-readable title for the error
     * @type {string}
     * @memberof ApiError
     */
    title: string;
    /**
     * A human-readable description of the error
     * @type {string}
     * @memberof ApiError
     */
    detail: string;
    /**
     * a URI that identifies the specific occurrence of the error
     * @type {string}
     * @memberof ApiError
     */
    instance?: string;
    /**
     * an error code which will uniquely identify the error
     * @type {string}
     * @memberof ApiError
     */
    code: string;
    /**
     * Unique identification value to trace the error
     * @type {string}
     * @memberof ApiError
     */
    traceId?: string;
    /**
     *
     * @type {Array<ApiErrorDetail>}
     * @memberof ApiError
     */
    details?: Array<ApiErrorDetail>;
}
/**
 *
 * @export
 * @interface ApiErrorDetail
 */
export interface ApiErrorDetail {
    /**
     * The field that caused the error. If the field is in the body, set this value to the JSON pointer to that field. Required for client-side errors.
     * @type {string}
     * @memberof ApiErrorDetail
     */
    field?: string;
    /**
     * Value of the field that caused the error
     * @type {string}
     * @memberof ApiErrorDetail
     */
    value?: string;
    /**
     * The reason for the error
     * @type {string}
     * @memberof ApiErrorDetail
     */
    reason: string;
    /**
     * The location of the field that caused the error
     * @type {string}
     * @memberof ApiErrorDetail
     */
    location?: ApiErrorDetailLocationEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum ApiErrorDetailLocationEnum {
    Body = 'BODY',
    Path = 'PATH',
    Query = 'QUERY',
}

/**
 *
 * @export
 * @interface ApiErrors
 */
export interface ApiErrors {
    /**
     *
     * @type {Array<ApiError>}
     * @memberof ApiErrors
     */
    errors: Array<ApiError>;
    /**
     * The HTTP response code
     * @type {number}
     * @memberof ApiErrors
     */
    status: number;
}
/**
 *
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * Attachment URL
     * @type {string}
     * @memberof Attachment
     */
    url: string;
    /**
     * Attachment type
     * @type {string}
     * @memberof Attachment
     */
    type?: string;
}
/**
 * Block user request payload
 * @export
 * @interface BlockUserRequest
 */
export interface BlockUserRequest {
    /**
     * User Id blocking the user
     * @type {number}
     * @memberof BlockUserRequest
     */
    id: number;
    /**
     * User Id to block
     * @type {number}
     * @memberof BlockUserRequest
     */
    targetUserId: number;
}
/**
 * Blocked User
 * @export
 * @interface BlockedUser
 */
export interface BlockedUser {
    /**
     * Blocked user Id
     * @type {number}
     * @memberof BlockedUser
     */
    id?: number;
}
/**
 * List of Blocked Users
 * @export
 * @interface BlockedUsersResponse
 */
export interface BlockedUsersResponse {
    /**
     *
     * @type {Array<BlockedUser>}
     * @memberof BlockedUsersResponse
     */
    users?: Array<BlockedUser>;
}
/**
 * API response
 * @export
 * @interface Conversation
 */
export interface Conversation {
    /**
     * seller user id
     * @type {number}
     * @memberof Conversation
     */
    sellerId?: number;
    /**
     * buyer user id
     * @type {number}
     * @memberof Conversation
     */
    buyerId?: number;
}
/**
 * Conversation response
 * @export
 * @interface ConversationResponse
 */
export interface ConversationResponse {
    /**
     * Conversation Id
     * @type {string}
     * @memberof ConversationResponse
     */
    id?: string;
    /**
     * Advert Id
     * @type {number}
     * @memberof ConversationResponse
     */
    adId?: number;
    /**
     * seller Id
     * @type {number}
     * @memberof ConversationResponse
     */
    sellerId?: number;
    /**
     * buyer Id
     * @type {number}
     * @memberof ConversationResponse
     */
    buyerId?: number;
    /**
     * Creation date
     * @type {string}
     * @memberof ConversationResponse
     */
    createdAt?: string;
    /**
     * Updated date
     * @type {string}
     * @memberof ConversationResponse
     */
    updatedAt?: string;
    /**
     * Unread message count in the conversation for the current user
     * @type {number}
     * @memberof ConversationResponse
     */
    unreadMessagesCount?: number;
    /**
     *
     * @type {Array<Message>}
     * @memberof ConversationResponse
     */
    messages?: Array<Message>;
}
/**
 *
 * @export
 * @interface DeviceId
 */
export interface DeviceId {
    /**
     * Device id
     * @type {string}
     * @memberof DeviceId
     */
    id: string;
}
/**
 * Device subscription request
 * @export
 * @interface DeviceSubscriptionRequest
 */
export interface DeviceSubscriptionRequest {
    /**
     * Device ID to subscribe
     * @type {string}
     * @memberof DeviceSubscriptionRequest
     */
    id: string;
    /**
     * User id of the subscribe device
     * @type {number}
     * @memberof DeviceSubscriptionRequest
     */
    userId: number;
}
/**
 * Get all the conversations response payload
 * @export
 * @interface GetAllConversationsResponse
 */
export interface GetAllConversationsResponse {
    /**
     *
     * @type {Array<ConversationResponse>}
     * @memberof GetAllConversationsResponse
     */
    conversations?: Array<ConversationResponse>;
}
/**
 *
 * @export
 * @interface HideResponse
 */
export interface HideResponse {
    /**
     * boolean describing if a conversation hide or not
     * @type {boolean}
     * @memberof HideResponse
     */
    value: boolean;
}
/**
 * Mark message as read payload
 * @export
 * @interface MarkMessageAsReadRequest
 */
export interface MarkMessageAsReadRequest {
    /**
     * Advert Id
     * @type {number}
     * @memberof MarkMessageAsReadRequest
     */
    adId: number;
    /**
     * Seller Id
     * @type {number}
     * @memberof MarkMessageAsReadRequest
     */
    sellerId: number;
    /**
     * Buyer Id
     * @type {number}
     * @memberof MarkMessageAsReadRequest
     */
    buyerId: number;
    /**
     * Action requested by user type
     * @type {string}
     * @memberof MarkMessageAsReadRequest
     */
    requestedBy: MarkMessageAsReadRequestRequestedByEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum MarkMessageAsReadRequestRequestedByEnum {
    Seller = 'SELLER',
    Buyer = 'BUYER',
}

/**
 * Mark message as read response
 * @export
 * @interface MarkMessageAsReadResponse
 */
export interface MarkMessageAsReadResponse {
    /**
     * Action result, true if conversation messages are marked as read
     * @type {boolean}
     * @memberof MarkMessageAsReadResponse
     */
    result?: boolean;
}
/**
 * Conversation message
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * Message Id
     * @type {string}
     * @memberof Message
     */
    id?: string;
    /**
     * message text
     * @type {string}
     * @memberof Message
     */
    text?: string;
    /**
     * Creation date
     * @type {string}
     * @memberof Message
     */
    createdAt?: string;
    /**
     * Updated date
     * @type {string}
     * @memberof Message
     */
    updatedAt?: string;
    /**
     * Message sender
     * @type {string}
     * @memberof Message
     */
    userRole?: MessageUserRoleEnum;
    /**
     * User Id
     * @type {number}
     * @memberof Message
     */
    userId?: number;
    /**
     * Message attachments
     * @type {Array<Attachment>}
     * @memberof Message
     */
    attachments?: Array<Attachment>;
}

export type JobMessage = Message;

/**
 * @export
 * @enum {string}
 */
export enum MessageUserRoleEnum {
    Buyer = 'BUYER',
    Seller = 'SELLER',
}

/**
 *
 * @export
 * @interface MessageId
 */
export interface MessageId {
    /**
     * Message id
     * @type {string}
     * @memberof MessageId
     */
    id: string;
}
/**
 * Meta data of the message
 * @export
 * @interface MetaData
 */
export interface MetaData {
    /**
     *
     * @type {AdMetaData}
     * @memberof MetaData
     */
    ad?: AdMetaData;
    /**
     * User agent from where message is sent
     * @type {string}
     * @memberof MetaData
     */
    userAgent?: string;
    /**
     * Encrypted IP address
     * @type {string}
     * @memberof MetaData
     */
    ipAddress?: string;
    /**
     * Encrypted EMG phone number
     * @type {string}
     * @memberof MetaData
     */
    emgPhoneNumber?: string;
    /**
     * Encrypted first name of the user
     * @type {string}
     * @memberof MetaData
     */
    firstName?: string;
    /**
     * Encrypted last name of the user
     * @type {string}
     * @memberof MetaData
     */
    lastName?: string;
    /**
     * Encrypted user\'s email id
     * @type {string}
     * @memberof MetaData
     */
    email?: string;
    /**
     * Category Id
     * @type {number}
     * @memberof MetaData
     */
    categoryId?: number;
    /**
     * User cookie
     * @type {string}
     * @memberof MetaData
     */
    cookie?: string;
    /**
     * Message type of the advert
     * @type {string}
     * @memberof MetaData
     */
    advertMessageType?: MetaDataAdvertMessageTypeEnum;
    /**
     * Origin of the message. Should first be in [CAPI-SERVER, BUYER-SERVER, SELLER-SERVER]
     * @type {string}
     * @memberof MetaData
     */
    origin?: string;
    /**
     *
     * @type {string}
     * @memberof MetaData
     */
    traceId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum MetaDataAdvertMessageTypeEnum {
    Gumtree = 'GUMTREE',
    Madgex = 'MADGEX',
    Trifecta = 'TRIFECTA',
}

/**
 * Send message request
 * @export
 * @interface SendMessageRequest
 */
export interface SendMessageRequest {
    /**
     * Advert Id
     * @type {number}
     * @memberof SendMessageRequest
     */
    adId: number;
    /**
     * Buyer Id
     * @type {number}
     * @memberof SendMessageRequest
     */
    buyerId: number;
    /**
     * Seller Id
     * @type {number}
     * @memberof SendMessageRequest
     */
    sellerId: number;
    /**
     * Who is sending the message BUYER or SELLER
     * @type {string}
     * @memberof SendMessageRequest
     */
    sender: SendMessageRequestSenderEnum;
    /**
     * Message text
     * @type {string}
     * @memberof SendMessageRequest
     */
    messageBody?: string;
    /**
     *
     * @type {MetaData}
     * @memberof SendMessageRequest
     */
    metaData?: MetaData;
}

/**
 * @export
 * @enum {string}
 */
export enum SendMessageRequestSenderEnum {
    Buyer = 'BUYER',
    Seller = 'SELLER',
}

/**
 * Unread message count response
 * @export
 * @interface UnreadMessageCountResponse
 */
export interface UnreadMessageCountResponse {
    /**
     * Unread count messages
     * @type {number}
     * @memberof UnreadMessageCountResponse
     */
    totalUnreadCount?: number;
}
/**
 * Generate channel request payload
 * @export
 * @interface ValidateChannelRequest
 */
export interface ValidateChannelRequest {
    /**
     * Advert Id
     * @type {number}
     * @memberof ValidateChannelRequest
     */
    adId: number;
    /**
     * Buyer Id
     * @type {number}
     * @memberof ValidateChannelRequest
     */
    buyerId: number;
    /**
     * Seller Id
     * @type {number}
     * @memberof ValidateChannelRequest
     */
    sellerId: number;
}
/**
 * Validate Channel response payload
 * @export
 * @interface ValidateChannelResponse
 */
export interface ValidateChannelResponse {
    /**
     * Channel Id
     * @type {string}
     * @memberof ValidateChannelResponse
     */
    id: string;
}

/**
 * ConversationApi - axios parameter creator
 * @export
 */
export const ConversationApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Get all conversations for a user
         * @param {number} userId User ID
         * @param {number} [offset] offset
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConversations: async (
            userId: number,
            offset?: number,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError(
                    'userId',
                    'Required parameter userId was null or undefined when calling getAllConversations.'
                );
            }
            const localVarPath = `/conversations/{user-id}`.replace(
                `{${'user-id'}}`,
                encodeURIComponent(String(userId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (offset !== undefined) {
                localVarQueryParameter.offset = offset;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a conversation
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {'SELLER' | 'BUYER'} requestedBy User requesting the conversation
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation: async (
            adId: number,
            buyerId: number,
            sellerId: number,
            requestedBy: 'SELLER' | 'BUYER',
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'adId' is not null or undefined
            if (adId === null || adId === undefined) {
                throw new RequiredError(
                    'adId',
                    'Required parameter adId was null or undefined when calling getConversation.'
                );
            }
            // verify required parameter 'buyerId' is not null or undefined
            if (buyerId === null || buyerId === undefined) {
                throw new RequiredError(
                    'buyerId',
                    'Required parameter buyerId was null or undefined when calling getConversation.'
                );
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError(
                    'sellerId',
                    'Required parameter sellerId was null or undefined when calling getConversation.'
                );
            }
            // verify required parameter 'requestedBy' is not null or undefined
            if (requestedBy === null || requestedBy === undefined) {
                throw new RequiredError(
                    'requestedBy',
                    'Required parameter requestedBy was null or undefined when calling getConversation.'
                );
            }
            const localVarPath = `/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (adId !== undefined) {
                localVarQueryParameter['ad-id'] = adId;
            }

            if (buyerId !== undefined) {
                localVarQueryParameter['buyer-id'] = buyerId;
            }

            if (sellerId !== undefined) {
                localVarQueryParameter['seller-id'] = sellerId;
            }

            if (requestedBy !== undefined) {
                localVarQueryParameter['requested-by'] = requestedBy;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a conversation
         * @param {number} userId User ID
         * @param {string} channelId Channel ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationById: async (
            userId: number,
            channelId: string,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError(
                    'userId',
                    'Required parameter userId was null or undefined when calling getConversationById.'
                );
            }
            // verify required parameter 'channelId' is not null or undefined
            if (channelId === null || channelId === undefined) {
                throw new RequiredError(
                    'channelId',
                    'Required parameter channelId was null or undefined when calling getConversationById.'
                );
            }
            const localVarPath = `/conversations/find-by-id/{channel-id}`.replace(
                `{${'channel-id'}}`,
                encodeURIComponent(String(channelId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user-id'] = userId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Hide conversation for person, who call this endpoint, if this conversation belongs to him
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideConversation: async (
            adId: number,
            buyerId: number,
            sellerId: number,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'adId' is not null or undefined
            if (adId === null || adId === undefined) {
                throw new RequiredError(
                    'adId',
                    'Required parameter adId was null or undefined when calling hideConversation.'
                );
            }
            // verify required parameter 'buyerId' is not null or undefined
            if (buyerId === null || buyerId === undefined) {
                throw new RequiredError(
                    'buyerId',
                    'Required parameter buyerId was null or undefined when calling hideConversation.'
                );
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError(
                    'sellerId',
                    'Required parameter sellerId was null or undefined when calling hideConversation.'
                );
            }
            const localVarPath = `/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (adId !== undefined) {
                localVarQueryParameter['ad-id'] = adId;
            }

            if (buyerId !== undefined) {
                localVarQueryParameter['buyer-id'] = buyerId;
            }

            if (sellerId !== undefined) {
                localVarQueryParameter['seller-id'] = sellerId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all messages in a conversations as read from latest message
         * @param {string} id Latest message id
         * @param {MarkMessageAsReadRequest} markMessageAsReadRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMessageAsRead: async (
            id: string,
            markMessageAsReadRequest: MarkMessageAsReadRequest,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling markMessageAsRead.'
                );
            }
            // verify required parameter 'markMessageAsReadRequest' is not null or undefined
            if (markMessageAsReadRequest === null || markMessageAsReadRequest === undefined) {
                throw new RequiredError(
                    'markMessageAsReadRequest',
                    'Required parameter markMessageAsReadRequest was null or undefined when calling markMessageAsRead.'
                );
            }
            const localVarPath = `/messages/{id}/mark-as-read`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof markMessageAsReadRequest !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(
                      markMessageAsReadRequest !== undefined ? markMessageAsReadRequest : {}
                  )
                : markMessageAsReadRequest || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a job message. The user can be a guest user
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {JobMessage} [jobMessage]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendJobMessage: async (
            authorization?: string,
            jobMessage?: JobMessage,
            attachment?: any,
            options: any = {}
        ): Promise<RequestArgs> => {
            const localVarPath = `/job-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) ||
                FormData)();

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            if (jobMessage !== undefined) {
                localVarFormParams.append(
                    'jobMessage',
                    new Blob([JSON.stringify(jobMessage)], { type: 'application/json' })
                );
            }

            if (attachment !== undefined) {
                localVarFormParams.append('attachment', attachment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a message
         * @param {SendMessageRequest} sendMessageRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: async (
            sendMessageRequest: SendMessageRequest,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'sendMessageRequest' is not null or undefined
            if (sendMessageRequest === null || sendMessageRequest === undefined) {
                throw new RequiredError(
                    'sendMessageRequest',
                    'Required parameter sendMessageRequest was null or undefined when calling sendMessage.'
                );
            }
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof sendMessageRequest !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(sendMessageRequest !== undefined ? sendMessageRequest : {})
                : sendMessageRequest || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a message with attachment
         * @param {string} [authorization] Authorisation token for bearer token. Adding the header explicitly for now to enable the client to send the bearer token for every request.
         * @param {SendMessageRequest} [messageRequest]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageWithAttachment: async (
            authorization?: string,
            messageRequest?: SendMessageRequest,
            attachment?: any,
            options: any = {}
        ): Promise<RequestArgs> => {
            const localVarPath = `/messages-with-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) ||
                FormData)();

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            if (messageRequest !== undefined) {
                localVarFormParams.append(
                    'messageRequest',
                    new Blob([JSON.stringify(messageRequest)], { type: 'application/json' })
                );
            }

            if (attachment !== undefined) {
                localVarFormParams.append('attachment', attachment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ConversationApi - functional programming interface
 * @export
 */
export const ConversationApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Get all conversations for a user
         * @param {number} userId User ID
         * @param {number} [offset] offset
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConversations(
            userId: number,
            offset?: number,
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllConversationsResponse>
        > {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).getAllConversations(userId, offset, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a conversation
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {'SELLER' | 'BUYER'} requestedBy User requesting the conversation
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversation(
            adId: number,
            buyerId: number,
            sellerId: number,
            requestedBy: 'SELLER' | 'BUYER',
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponse>
        > {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).getConversation(adId, buyerId, sellerId, requestedBy, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a conversation
         * @param {number} userId User ID
         * @param {string} channelId Channel ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationById(
            userId: number,
            channelId: string,
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponse>
        > {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).getConversationById(userId, channelId, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Hide conversation for person, who call this endpoint, if this conversation belongs to him
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideConversation(
            adId: number,
            buyerId: number,
            sellerId: number,
            authorization?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HideResponse>> {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).hideConversation(adId, buyerId, sellerId, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Mark all messages in a conversations as read from latest message
         * @param {string} id Latest message id
         * @param {MarkMessageAsReadRequest} markMessageAsReadRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markMessageAsRead(
            id: string,
            markMessageAsReadRequest: MarkMessageAsReadRequest,
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkMessageAsReadResponse>
        > {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).markMessageAsRead(id, markMessageAsReadRequest, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send a job message. The user can be a guest user
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {JobMessage} [jobMessage]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendJobMessage(
            authorization?: string,
            jobMessage?: JobMessage,
            attachment?: any,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageId>> {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).sendJobMessage(authorization, jobMessage, attachment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send a message
         * @param {SendMessageRequest} sendMessageRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessage(
            sendMessageRequest: SendMessageRequest,
            authorization?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageId>> {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).sendMessage(sendMessageRequest, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send a message with attachment
         * @param {string} [authorization] Authorisation token for bearer token. Adding the header explicitly for now to enable the client to send the bearer token for every request.
         * @param {SendMessageRequest} [messageRequest]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessageWithAttachment(
            authorization?: string,
            messageRequest?: SendMessageRequest,
            attachment?: any,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageId>> {
            const localVarAxiosArgs = await ConversationApiAxiosParamCreator(
                configuration
            ).sendMessageWithAttachment(authorization, messageRequest, attachment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ConversationApi - factory interface
 * @export
 */
export const ConversationApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Get all conversations for a user
         * @param {number} userId User ID
         * @param {number} [offset] offset
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConversations(
            userId: number,
            offset?: number,
            authorization?: string,
            options?: any
        ): AxiosPromise<GetAllConversationsResponse> {
            return ConversationApiFp(configuration)
                .getAllConversations(userId, offset, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a conversation
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {'SELLER' | 'BUYER'} requestedBy User requesting the conversation
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(
            adId: number,
            buyerId: number,
            sellerId: number,
            requestedBy: 'SELLER' | 'BUYER',
            authorization?: string,
            options?: any
        ): AxiosPromise<ConversationResponse> {
            return ConversationApiFp(configuration)
                .getConversation(adId, buyerId, sellerId, requestedBy, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a conversation
         * @param {number} userId User ID
         * @param {string} channelId Channel ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationById(
            userId: number,
            channelId: string,
            authorization?: string,
            options?: any
        ): AxiosPromise<ConversationResponse> {
            return ConversationApiFp(configuration)
                .getConversationById(userId, channelId, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Hide conversation for person, who call this endpoint, if this conversation belongs to him
         * @param {number} adId Advert ID
         * @param {number} buyerId Buyer ID
         * @param {number} sellerId Seller ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideConversation(
            adId: number,
            buyerId: number,
            sellerId: number,
            authorization?: string,
            options?: any
        ): AxiosPromise<HideResponse> {
            return ConversationApiFp(configuration)
                .hideConversation(adId, buyerId, sellerId, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Mark all messages in a conversations as read from latest message
         * @param {string} id Latest message id
         * @param {MarkMessageAsReadRequest} markMessageAsReadRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMessageAsRead(
            id: string,
            markMessageAsReadRequest: MarkMessageAsReadRequest,
            authorization?: string,
            options?: any
        ): AxiosPromise<MarkMessageAsReadResponse> {
            return ConversationApiFp(configuration)
                .markMessageAsRead(id, markMessageAsReadRequest, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Send a job message. The user can be a guest user
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {JobMessage} [jobMessage]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendJobMessage(
            authorization?: string,
            jobMessage?: JobMessage,
            attachment?: any,
            options?: any
        ): AxiosPromise<MessageId> {
            return ConversationApiFp(configuration)
                .sendJobMessage(authorization, jobMessage, attachment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Send a message
         * @param {SendMessageRequest} sendMessageRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(
            sendMessageRequest: SendMessageRequest,
            authorization?: string,
            options?: any
        ): AxiosPromise<MessageId> {
            return ConversationApiFp(configuration)
                .sendMessage(sendMessageRequest, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Send a message with attachment
         * @param {string} [authorization] Authorisation token for bearer token. Adding the header explicitly for now to enable the client to send the bearer token for every request.
         * @param {SendMessageRequest} [messageRequest]
         * @param {any} [attachment] File attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageWithAttachment(
            authorization?: string,
            messageRequest?: SendMessageRequest,
            attachment?: any,
            options?: any
        ): AxiosPromise<MessageId> {
            return ConversationApiFp(configuration)
                .sendMessageWithAttachment(authorization, messageRequest, attachment, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConversationApi - object-oriented interface
 * @export
 * @class ConversationApi
 * @extends {BaseAPI}
 */
export class ConversationApi extends BaseAPI {
    /**
     * Get all conversations for a user
     * @param {number} userId User ID
     * @param {number} [offset] offset
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public getAllConversations(
        userId: number,
        offset?: number,
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .getAllConversations(userId, offset, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a conversation
     * @param {number} adId Advert ID
     * @param {number} buyerId Buyer ID
     * @param {number} sellerId Seller ID
     * @param {'SELLER' | 'BUYER'} requestedBy User requesting the conversation
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public getConversation(
        adId: number,
        buyerId: number,
        sellerId: number,
        requestedBy: 'SELLER' | 'BUYER',
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .getConversation(adId, buyerId, sellerId, requestedBy, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a conversation
     * @param {number} userId User ID
     * @param {string} channelId Channel ID
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public getConversationById(
        userId: number,
        channelId: string,
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .getConversationById(userId, channelId, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hide conversation for person, who call this endpoint, if this conversation belongs to him
     * @param {number} adId Advert ID
     * @param {number} buyerId Buyer ID
     * @param {number} sellerId Seller ID
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public hideConversation(
        adId: number,
        buyerId: number,
        sellerId: number,
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .hideConversation(adId, buyerId, sellerId, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all messages in a conversations as read from latest message
     * @param {string} id Latest message id
     * @param {MarkMessageAsReadRequest} markMessageAsReadRequest
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public markMessageAsRead(
        id: string,
        markMessageAsReadRequest: MarkMessageAsReadRequest,
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .markMessageAsRead(id, markMessageAsReadRequest, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a job message. The user can be a guest user
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {JobMessage} [jobMessage]
     * @param {any} [attachment] File attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public sendJobMessage(
        authorization?: string,
        jobMessage?: JobMessage,
        attachment?: any,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .sendJobMessage(authorization, jobMessage, attachment, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a message
     * @param {SendMessageRequest} sendMessageRequest
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public sendMessage(
        sendMessageRequest: SendMessageRequest,
        authorization?: string,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .sendMessage(sendMessageRequest, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a message with attachment
     * @param {string} [authorization] Authorisation token for bearer token. Adding the header explicitly for now to enable the client to send the bearer token for every request.
     * @param {SendMessageRequest} [messageRequest]
     * @param {any} [attachment] File attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationApi
     */
    public sendMessageWithAttachment(
        authorization?: string,
        messageRequest?: SendMessageRequest,
        attachment?: any,
        options?: any
    ) {
        return ConversationApiFp(this.configuration)
            .sendMessageWithAttachment(authorization, messageRequest, attachment, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Get unread message counts for a user
         * @param {number} userId User ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount: async (
            userId: number,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError(
                    'userId',
                    'Required parameter userId was null or undefined when calling getUnreadMessageCount.'
                );
            }
            const localVarPath = `/messages/unread/{user-id}`.replace(
                `{${'user-id'}}`,
                encodeURIComponent(String(userId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Get unread message counts for a user
         * @param {number} userId User ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadMessageCount(
            userId: number,
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadMessageCountResponse>
        > {
            const localVarAxiosArgs = await MessageApiAxiosParamCreator(
                configuration
            ).getUnreadMessageCount(userId, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Get unread message counts for a user
         * @param {number} userId User ID
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount(
            userId: number,
            authorization?: string,
            options?: any
        ): AxiosPromise<UnreadMessageCountResponse> {
            return MessageApiFp(configuration)
                .getUnreadMessageCount(userId, authorization, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI {
    /**
     * Get unread message counts for a user
     * @param {number} userId User ID
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public getUnreadMessageCount(userId: number, authorization?: string, options?: any) {
        return MessageApiFp(this.configuration)
            .getUnreadMessageCount(userId, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PushNotificationsApi - axios parameter creator
 * @export
 */
export const PushNotificationsApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Subscribe a device for push notifications
         * @param {DeviceSubscriptionRequest} deviceSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeDevice: async (
            deviceSubscriptionRequest: DeviceSubscriptionRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'deviceSubscriptionRequest' is not null or undefined
            if (deviceSubscriptionRequest === null || deviceSubscriptionRequest === undefined) {
                throw new RequiredError(
                    'deviceSubscriptionRequest',
                    'Required parameter deviceSubscriptionRequest was null or undefined when calling subscribeDevice.'
                );
            }
            const localVarPath = `/push-notification/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof deviceSubscriptionRequest !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(
                      deviceSubscriptionRequest !== undefined ? deviceSubscriptionRequest : {}
                  )
                : deviceSubscriptionRequest || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Unsubscribe a device for push notifications
         * @param {string} id Device ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeDevice: async (
            id: string,
            userId: number,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling unsubscribeDevice.'
                );
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError(
                    'userId',
                    'Required parameter userId was null or undefined when calling unsubscribeDevice.'
                );
            }
            const localVarPath = `/push-notification/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (id !== undefined) {
                localVarQueryParameter.id = id;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user-id'] = userId;
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * PushNotificationsApi - functional programming interface
 * @export
 */
export const PushNotificationsApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Subscribe a device for push notifications
         * @param {DeviceSubscriptionRequest} deviceSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeDevice(
            deviceSubscriptionRequest: DeviceSubscriptionRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceId>> {
            const localVarAxiosArgs = await PushNotificationsApiAxiosParamCreator(
                configuration
            ).subscribeDevice(deviceSubscriptionRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unsubscribe a device for push notifications
         * @param {string} id Device ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeDevice(
            id: string,
            userId: number,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceId>> {
            const localVarAxiosArgs = await PushNotificationsApiAxiosParamCreator(
                configuration
            ).unsubscribeDevice(id, userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * PushNotificationsApi - factory interface
 * @export
 */
export const PushNotificationsApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Subscribe a device for push notifications
         * @param {DeviceSubscriptionRequest} deviceSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeDevice(
            deviceSubscriptionRequest: DeviceSubscriptionRequest,
            options?: any
        ): AxiosPromise<DeviceId> {
            return PushNotificationsApiFp(configuration)
                .subscribeDevice(deviceSubscriptionRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe a device for push notifications
         * @param {string} id Device ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeDevice(id: string, userId: number, options?: any): AxiosPromise<DeviceId> {
            return PushNotificationsApiFp(configuration)
                .unsubscribeDevice(id, userId, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * PushNotificationsApi - object-oriented interface
 * @export
 * @class PushNotificationsApi
 * @extends {BaseAPI}
 */
export class PushNotificationsApi extends BaseAPI {
    /**
     * Subscribe a device for push notifications
     * @param {DeviceSubscriptionRequest} deviceSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationsApi
     */
    public subscribeDevice(deviceSubscriptionRequest: DeviceSubscriptionRequest, options?: any) {
        return PushNotificationsApiFp(this.configuration)
            .subscribeDevice(deviceSubscriptionRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unsubscribe a device for push notifications
     * @param {string} id Device ID
     * @param {number} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationsApi
     */
    public unsubscribeDevice(id: string, userId: number, options?: any) {
        return PushNotificationsApiFp(this.configuration)
            .unsubscribeDevice(id, userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Block user
         * @param {BlockUserRequest} blockUserRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser: async (
            blockUserRequest: BlockUserRequest,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockUserRequest' is not null or undefined
            if (blockUserRequest === null || blockUserRequest === undefined) {
                throw new RequiredError(
                    'blockUserRequest',
                    'Required parameter blockUserRequest was null or undefined when calling blockUser.'
                );
            }
            const localVarPath = `/users/block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof blockUserRequest !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(blockUserRequest !== undefined ? blockUserRequest : {})
                : blockUserRequest || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of users blocked by a user
         * @param {number} blockerId Blocker user Id
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersBlockedByTheUser: async (
            blockerId: number,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockerId' is not null or undefined
            if (blockerId === null || blockerId === undefined) {
                throw new RequiredError(
                    'blockerId',
                    'Required parameter blockerId was null or undefined when calling getUsersBlockedByTheUser.'
                );
            }
            const localVarPath = `/users/{blocker-id}/blocked-users`.replace(
                `{${'blocker-id'}}`,
                encodeURIComponent(String(blockerId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Unblock a blocked user
         * @param {number} blockerId Blocker user Id
         * @param {number} blockeeId User id to unblock
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockAUser: async (
            blockerId: number,
            blockeeId: number,
            authorization?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockerId' is not null or undefined
            if (blockerId === null || blockerId === undefined) {
                throw new RequiredError(
                    'blockerId',
                    'Required parameter blockerId was null or undefined when calling unblockAUser.'
                );
            }
            // verify required parameter 'blockeeId' is not null or undefined
            if (blockeeId === null || blockeeId === undefined) {
                throw new RequiredError(
                    'blockeeId',
                    'Required parameter blockeeId was null or undefined when calling unblockAUser.'
                );
            }
            const localVarPath = `/users/{blocker-id}/blocked-users/{blockee-id}`
                .replace(`{${'blocker-id'}}`, encodeURIComponent(String(blockerId)))
                .replace(`{${'blockee-id'}}`, encodeURIComponent(String(blockeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Block user
         * @param {BlockUserRequest} blockUserRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockUser(
            blockUserRequest: BlockUserRequest,
            authorization?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).blockUser(
                blockUserRequest,
                authorization,
                options
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get list of users blocked by a user
         * @param {number} blockerId Blocker user Id
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersBlockedByTheUser(
            blockerId: number,
            authorization?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedUsersResponse>
        > {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(
                configuration
            ).getUsersBlockedByTheUser(blockerId, authorization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unblock a blocked user
         * @param {number} blockerId Blocker user Id
         * @param {number} blockeeId User id to unblock
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockAUser(
            blockerId: number,
            blockeeId: number,
            authorization?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).unblockAUser(
                blockerId,
                blockeeId,
                authorization,
                options
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Block user
         * @param {BlockUserRequest} blockUserRequest
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(
            blockUserRequest: BlockUserRequest,
            authorization?: string,
            options?: any
        ): AxiosPromise<void> {
            return UserApiFp(configuration)
                .blockUser(blockUserRequest, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get list of users blocked by a user
         * @param {number} blockerId Blocker user Id
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersBlockedByTheUser(
            blockerId: number,
            authorization?: string,
            options?: any
        ): AxiosPromise<BlockedUsersResponse> {
            return UserApiFp(configuration)
                .getUsersBlockedByTheUser(blockerId, authorization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Unblock a blocked user
         * @param {number} blockerId Blocker user Id
         * @param {number} blockeeId User id to unblock
         * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockAUser(
            blockerId: number,
            blockeeId: number,
            authorization?: string,
            options?: any
        ): AxiosPromise<void> {
            return UserApiFp(configuration)
                .unblockAUser(blockerId, blockeeId, authorization, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Block user
     * @param {BlockUserRequest} blockUserRequest
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public blockUser(blockUserRequest: BlockUserRequest, authorization?: string, options?: any) {
        return UserApiFp(this.configuration)
            .blockUser(blockUserRequest, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of users blocked by a user
     * @param {number} blockerId Blocker user Id
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsersBlockedByTheUser(blockerId: number, authorization?: string, options?: any) {
        return UserApiFp(this.configuration)
            .getUsersBlockedByTheUser(blockerId, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unblock a blocked user
     * @param {number} blockerId Blocker user Id
     * @param {number} blockeeId User id to unblock
     * @param {string} [authorization] Bearer token for authorization. Adding the header explicitly as a new token is required for every request and there are issue to send it from underlying service because of the generator.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public unblockAUser(
        blockerId: number,
        blockeeId: number,
        authorization?: string,
        options?: any
    ) {
        return UserApiFp(this.configuration)
            .unblockAUser(blockerId, blockeeId, authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ValidationApi - axios parameter creator
 * @export
 */
export const ValidationApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Validate channel id
         * @param {string} [authorization] Bearer token for authorization
         * @param {ValidateChannelRequest} [validateChannelRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateChannelId: async (
            authorization?: string,
            validateChannelRequest?: ValidateChannelRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            const localVarPath = `/validate/channel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtSchema required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken =
                    typeof configuration.accessToken === 'function'
                        ? await configuration.accessToken()
                        : await configuration.accessToken;
                localVarHeaderParameter.Authorization = `Bearer ${accessToken}`;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter.authorization = String(authorization);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof validateChannelRequest !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(validateChannelRequest !== undefined ? validateChannelRequest : {})
                : validateChannelRequest || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ValidationApi - functional programming interface
 * @export
 */
export const ValidationApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Validate channel id
         * @param {string} [authorization] Bearer token for authorization
         * @param {ValidateChannelRequest} [validateChannelRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateChannelId(
            authorization?: string,
            validateChannelRequest?: ValidateChannelRequest,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateChannelResponse>
        > {
            const localVarAxiosArgs = await ValidationApiAxiosParamCreator(
                configuration
            ).validateChannelId(authorization, validateChannelRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ValidationApi - factory interface
 * @export
 */
export const ValidationApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Validate channel id
         * @param {string} [authorization] Bearer token for authorization
         * @param {ValidateChannelRequest} [validateChannelRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateChannelId(
            authorization?: string,
            validateChannelRequest?: ValidateChannelRequest,
            options?: any
        ): AxiosPromise<ValidateChannelResponse> {
            return ValidationApiFp(configuration)
                .validateChannelId(authorization, validateChannelRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationApi - object-oriented interface
 * @export
 * @class ValidationApi
 * @extends {BaseAPI}
 */
export class ValidationApi extends BaseAPI {
    /**
     * Validate channel id
     * @param {string} [authorization] Bearer token for authorization
     * @param {ValidateChannelRequest} [validateChannelRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public validateChannelId(
        authorization?: string,
        validateChannelRequest?: ValidateChannelRequest,
        options?: any
    ) {
        return ValidationApiFp(this.configuration)
            .validateChannelId(authorization, validateChannelRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
